export default "__VITE_ASSET__DfeiLCYZ__"